// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}
:host .show-password {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1;
  min-height: 3rem;
  min-width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-dark);
}
:host .show-password ion-icon {
  padding: 1rem;
  font-size: 1.125rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form-field/show-hide-password/show-hide-password.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;AACN","sourcesContent":[":host {\n  position: relative;\n\n  .show-password {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    z-index: 1;\n    min-height: 3rem;\n    min-width: 3rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--ion-color-dark);\n\n    ion-icon {\n      padding: 1rem;\n      font-size: 1.125rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
